'use strict';

import {ChangeLogListCtrl} from './changeloglistctrl.js';

import {changelogModel} from "../../models/changelogmodel.js";

export class InvitationChangeLogListCtrl extends ChangeLogListCtrl
{
	storageNames = {
		query: 'InvitationChangeLogListCtrl'
	};
	
}


